module.exports = __webpack_public_path__ + "assets/images/family_r.c2261bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/family_r.png
// module id = 709
// module chunks = 1